module.exports = __webpack_public_path__ + "img/56_52.c4807e49.png";